/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cognito_identity_pool_id": "eu-west-2:e1276c18-451a-403f-8c39-562058edc818",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_P9koX6FuF",
    "aws_user_pools_web_client_id": "71te4kgr47ctgkqn86l0g18flj",
    "oauth": {
        "domain": "sleeptrack-auth-sleeptrack-sleeptrack.auth.eu-west-2.amazoncognito.com",
        "scope": [
            "email",
            "openid",
            "profile"
        ],
        "redirectSignIn": "http://localhost:3000/,https://main.d1enoye8oaet5d.amplifyapp.com/",
        "redirectSignOut": "http://localhost:3000/,https://main.d1enoye8oaet5d.amplifyapp.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [],
    "aws_dynamodb_all_tables_region": "eu-west-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "sleeptrackTable-sleeptrack",
            "region": "eu-west-2"
        }
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "tbuaxjg6e6",
            "endpoint": "https://tbuaxjg6e6.execute-api.eu-west-2.amazonaws.com/sleeptrack",
            "region": "eu-west-2"
        }
    ]
};


export default awsmobile;
